<template>
    <div>
        <div class="title">
            <h4 class="mb-0">Buy Now Pay Later</h4>
        </div>
        <div class="d-flex justify-content-end mb-3"></div>
        <div>
            <LoaderList v-if="isLoading" class="w-100" />
            <div v-else class="table-responsive">
                <table class="table list">
                    <thead>
                        <tr>
                            <th width="10%">Name:</th>
                            <th width="65%">Term & Condition:</th>
                            <th width="10%">Last Update:</th>
                            <th width="10%">Status:</th>
                        </tr>
                    </thead>
                    <tbody v-if="BNPLs && BNPLs.length">
                        <template v-for="BNPL in BNPLs">
                            <tr :key="'row-' + BNPL.id" :id="'row-' + BNPL.id">
                                <td>{{ BNPL.name }}</td>
                                <td>{{ BNPL.description }}</td>
                                <td>
                                    {{ _carbonDateDisplay(BNPL.last_update) }}
                                </td>
                                <td>
                                    <div
                                        class="green-toggle custom-control custom-switch"
                                    >
                                        <input
                                            :id="BNPL.id"
                                            type="checkbox"
                                            class="custom-control-input"
                                            v-model="BNPL.status"
                                            :value="BNPL.status"
                                            @change="onStatusToggled(BNPL)"
                                            true-value="1"
                                            false-value="0"
                                        />
                                        <label
                                            class="custom-control-label"
                                            :for="BNPL.id"
                                            >{{
                                                BNPL.status == 1
                                                    ? "Active"
                                                    : "Inactive"
                                            }}</label
                                        >
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="9">
                                <i>No records available</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import Payment from "@/services/payment";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue")
    },
    props: {
        bnplPaymentType: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            isLoading: false,
            BNPLs: []
        };
    },
    computed: {},
    created() {
        if (this.bnplPaymentType) {
            this.BNPLs.push({
                id: this.bnplPaymentType.id,
                name: "Sunbit via Stripe",
                description:
                    "Offer your clients the option to pay over time with Sunbit. Clients can quickly pre-qualify using just their phone number and address, with no impact on their credit score. Sunbit funds the clinic within 3-5 business days. There's a processing fee of 5.5% + $0.30 on approved loans, with a minimum $60 loan amount. This can help clients access services and products they might otherwise delay, increasing overall revenue potential. Terms and conditions apply.",
                last_update: this.bnplPaymentType.update_at,
                status: this.bnplPaymentType.status,
                oriData: this.bnplPaymentType
            });
        }
    },
    watch: {
        bnplPaymentType: {
            handler(newValue) {
                if (newValue && Object.keys(newValue).length) {
                    let existingBnpl = this.BNPLs.find(
                        bnpl => bnpl.id === newValue.id
                    );

                    if (existingBnpl) {
                        existingBnpl.status = newValue.status;
                        existingBnpl.last_update = newValue.update_at;
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        onStatusToggled(data) {
            if (data) {
                let newData = {
                    id: data.id,
                    status: data.status,
                    name: data.oriData.name,
                    category_id: data.oriData.category_id
                };
                Payment.updateBnplPaymentType(data.id, newData).then(
                    response => {
                        if (response.message.code == 200) {
                            this._message("Successfully updated", "success");
                        } else {
                            this._message("Update failed", "danger");
                        }
                    }
                );
            }
        }
    }
};
</script>

<style scoped></style>
